import apiClient from './client';

export const orderApi = {
  /**
   * Submit a new order (equity or mleg when legs provided)
   */
  submitOrder: async (orderData) => {
    const response = await apiClient.post('/api/orders', orderData);
    return response.data;
  },

  /**
   * Submit a multi-leg options order
   */
  submitMultiLegOrder: async (orderData) => {
    const response = await apiClient.post('/api/orders/mleg', orderData);
    return response.data;
  },

  /**
   * Submit multiple equity orders (basket)
   */
  submitBatchOrders: async (orderData) => {
    const response = await apiClient.post('/api/orders/batch', orderData);
    return response.data;
  },

  /**
   * Submit equity orders in sequence (one triggers the next on fill/accept)
   */
  submitChainedOrders: async (orderData) => {
    const response = await apiClient.post('/api/orders/chain', orderData, {
      timeout: 35 * 60 * 1000,
    });
    return response.data;
  },

  /**
   * Submit OTO / bracket / OCO (Alpaca advanced)
   */
  submitOtoOrder: async (orderData) => {
    const response = await apiClient.post('/api/orders/oto', orderData);
    return response.data;
  },

  /**
   * Get all orders
   */
  getOrders: async (filters = {}) => {
    const response = await apiClient.get('/api/orders', { params: filters });
    return response.data;
  },

  /**
   * Get order by ID
   */
  getOrder: async (orderId) => {
    const response = await apiClient.get(`/api/orders/${orderId}`);
    return response.data;
  },

  /**
   * Cancel an order
   */
  cancelOrder: async (orderId) => {
    const response = await apiClient.delete(`/api/orders/${orderId}`);
    return response.data;
  },

  /**
   * Replace/modify an order
   */
  replaceOrder: async (orderId, orderParams) => {
    const response = await apiClient.put(`/api/orders/${orderId}`, orderParams);
    return response.data;
  },
};


